export default __webpack_public_path__ + "static/media/g6.3f9b6ee6.jpg";